import React from 'react';

import ProductList from 'views/product/ProductList';
import Immutable from 'immutable';

import Tabs from 'muicss/lib/react/tabs';
import Tab from 'muicss/lib/react/tab';
import AppConstants from 'AppConstants';
import Loader from 'views/Loader';

const PRODUCT_TYPES = AppConstants.PRODUCT_TYPES;

const ProductTabs = ({products, ownerName, productViewMode}) => {

	const availableTypes = Object.keys(PRODUCT_TYPES);
	let productTypes = products? Immutable.Set(products.map(p => PRODUCT_TYPES[p.productType])).toArray(): 
									[{val: "dummyTab", label: <Loader style={{width: '70px'}}/>}];

	if(productTypes.length === 0) {
		productTypes.push(PRODUCT_TYPES.T_SHIRT);
	} else {
		productTypes = productTypes.sort((e1, e2) => {
			const i1 = availableTypes.indexOf(e1.val);
			const i2 = availableTypes.indexOf(e2.val);
			if(i1 < i2) return -1;
			if(i1 > i2) return 1;
			return 0;
		});
	}
	

	const tabs = productTypes.map(productType => {
		const filteredProducts = products? products.filter(p => p.productType === productType.val): null;
		
		const emptyMessage = typeof productType.label === "string"? "No "+productType.label+" Available": "";
		return <Tab key={ownerName+"-"+productType.val} value={productType.val} label={productType.label}>
					<ProductList products={filteredProducts} productViewMode={productViewMode}
						flattenProductImages={true} viewProductTags={true} emptyMsg={emptyMessage}/>
		</Tab>
	});

	return <Tabs defaultSelectedIndex={0} key={ownerName} style={{minHeight: '300px'}}>
			{tabs}
		</Tabs>
}


export default ProductTabs;


// WEBPACK FOOTER //
// ./src/views/product/ProductTabsByType.js